"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function isEmptyObject(obj) {
    if (!obj) {
        return true;
    }
    for (var key in obj) {
        if (Object.hasOwnProperty.call(obj, key)) {
            return false;
        }
    }
    return true;
}
exports.default = isEmptyObject;
//# sourceMappingURL=isEmptyObject.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/graphql-tools/dist/isEmptyObject.js
// module id = 408
// module chunks = 1